import view from '../../view';
import globals from '../../globals';
import { UPDATE_LIVE_ONLY, UPDATE_BOTH } from '../../hdrm/constants/update-strategies';

import saveMutation from '../actions/save-mutation';
import createMutation from '../helpers/create-mutation';

const mutationCreator = (store) => (next) => (action) => {
  switch (action.type) {
    case view.actionTypes.CHANGE_HTML:
    case view.actionTypes.SYNCHRONIZE_ELEMENT:
    case view.actionTypes.CUT_ELEMENT:
    case view.actionTypes.DELETE_ELEMENT:
    case view.actionTypes.DUPLICATE_ELEMENT:
    case view.actionTypes.INSERT_ELEMENT:
    case view.actionTypes.INSERT_BLOCK:
    case view.actionTypes.REPLACE_ELEMENT:
    case view.actionTypes.REMOVE_ELEMENT_ATTRIBUTE:
    case view.actionTypes.SET_ELEMENT_ATTRIBUTE:
    case view.actionTypes.SET_INLINE_ELEMENT_STYLE:
    case view.actionTypes.SHIFT_ELEMENT:
    case view.actionTypes.BULK_VIEW_ACTIONS:
    case globals.actionTypes.SET_GLOBAL_HTML_AND_AFFECT_HISTORY:
    case view.actionTypes.PASTE_ELEMENT:
    case view.actionTypes.SET_CHILDREN_PRESENCE:
    case view.actionTypes.UPDATE_ATOMIC_CSS:
    case view.actionTypes.BULK_SET_CHILDREN_PRESENCE: {
      const { options = {} } = action.payload;
      const { strategy = UPDATE_BOTH } = options;

      if (strategy !== UPDATE_LIVE_ONLY) {
        const mutation = createMutation(action);
        store.dispatch(saveMutation(mutation));
      }

      next(action);
      break;
    }

    default: {
      next(action);
      break;
    }
  }
};

export default mutationCreator;
